import { ILevelRequestModel } from '../../models/requests/LevelRequestModel'
import { ILevelModel } from '../../models/responses/LevelModel'
import { PagedResponseModel } from '../../models/responses/PagedResponseModel'
import { IPaginationFilter, generateQueryParams } from '../../models/requests/PaginationFilter'
import API from './Api'

class LevelApi {

  async GetLevels(filter: IPaginationFilter) {
    return await API.get<PagedResponseModel<ILevelModel[]>>(`e/Admin/Levels${generateQueryParams(filter)}`)
  }

  async GetLevelDictionary() {
    return await API.get<ILevelModel[]>(`e/Admin/Levels/dictionary`)
  }

  async GetLevel(id: number) {
    return await API.get<ILevelModel>('e/Admin/Levels/' + id)
  }

  async AddLevel(model: ILevelRequestModel) {
    return await API.post('e/Admin/Levels', model)
  }

  async UpdateLevel(model: ILevelRequestModel) {
    return await API.put('e/Admin/Levels/' + model.id, model)
  }

  async DeleteLevel(itemId: number) {
    return await API.delete<boolean>('e/Admin/Levels/' + itemId)
  }
}

export default new LevelApi()
